exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.3@core-js/library/modules/_wks-ext.js
// module id = 75
// module chunks = 1